<template>
  <div>
     <div class="row mx-auto justify-content-center" >
<filtro-servizio v-model="selectedservizio"/>
<filtro-stato v-model="selectedstato"/>
<cerca @cerca="smistaEfiltra"/>
     </div>
    <list-segnalazioni-com
    ref="listSegnalazioni"
    class=" mt-10 mx-auto "
    :codiceComune="codiceComune"
    :selectedservizio="selectedservizio"
    :selectedstato="selectedstato"
    :filtri="filtri" />

  </div>
</template>

<script>

import ComuniDataService from '@/service/ComuniDataService.js'
import listSegnalazioniCom from '../../components/list-segnalazioni-com.vue'
import FiltroServizio from '../../components/filtroServizio.vue'
import FiltroStato from '../../components/filtroStato.vue'
import Cerca from '../../components/cerca.vue'

export default {
  components: { listSegnalazioniCom, FiltroServizio, FiltroStato, Cerca },
  name: 'Comune',
  data () {
    return {
      ilComune: this.$store.getters.getComune,
      codiceComune: this.$store.getters.getComune.codiceCatasto,
      selectedservizio: null,
      selectedstato: null,
      filtri: [this.selectedservizio, this.selectedstato]
    }
  },
  methods: {
    caricaInfoComune (id) {
      return ComuniDataService
        .getComuneById(id)
        .then(response => {
          this.$store.dispatch('logAsAdmin', response.data)
          this.$store.dispatch('setTheme', response.data.codiceCatasto)
          // set title
          document.title = response.data.nome
          console.log(response.data)
          return response.data
        })
        .catch(e => {
          console.log(e)
          return null
        })
    },

    smistaEfiltra (a) {
      this.$refs.listSegnalazioni.smista(a)
    }

  },
  created () {
    this.caricaInfoComune(this.$store.getters.getComune.codiceCatasto).then(risultato => {
      if (!risultato) {
        this.caricaInfoComune(this.$route.params.cid).then(risultato => {
          console.log('params')
          this.ilComune = risultato
          this.codiceComune = this.ilComune.codiceCatasto
        })
      } else {
        console.log('getteer')
        this.ilComune = risultato
        this.codiceComune = this.ilComune.codiceCatasto
      }
    })
  },
  computed: {
    comuneStore () { return this.$store.getters.getComune.codiceCatasto }
  },
  watch: {
    $route: function (rot) {
      console.log('rot -->', rot)
      this.caricaInfoComune(rot.params.cid).then(risultato => {
        console.log('params')
        this.ilComune = risultato
        this.codiceComune = risultato.codiceCatasto
      })
    },
    comuneStore (storecomune) {
      this.caricaInfoComune(storecomune).then(risultato => {
        if (risultato === null) {
          this.caricaInfoComune(this.$route.params.cid).then(risultato => {
            console.log('params')
            this.ilComune = risultato
            this.codiceComune = this.ilComune.codiceCatasto
          })
        } else {
          console.log('getteer')
          this.ilComune = risultato
          this.codiceComune = this.ilComune.codiceCatasto
        }
      })
    },
    selectedstato: function (st) {
      this.filtri = [this.selectedservizio, st]
    },
    selectedservizio: function (st) {
      this.filtri = [st, this.selectedstato]
    }
  }
}
</script>
